export const DEFAULT_IMAGE_ICON_SIZE = 33;

export const DEFAULT_IMAGE_SIZE = 60;

export const NUMBER_OF_OPTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;
export const NUMBER_OF_PROJECTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;
export const MAX_DESCRIPTION_LINE_LENGTH = 500;
export const MAX_MODIFIER_LENGTH = 485;

export const SPECS = {
  CheckoutExcludeGoogleAutoCompleteOld: 'specs.stores.CheckoutExcludeGoogleAutoComplete',
  CheckoutExcludeGoogleAutoComplete: 'specs.ecom.CheckoutExcludeGoogleAutoComplete',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  AlwaysSendCurrencyHeader: 'specs.ecom.AlwaysSendCurrencyHeader',
  SupportManualPaymentsOnPaymentRequest: 'specs.ecom.SupportManualPaymentsOnPaymentRequest',
  ShowVoidedErrorMessage: 'specs.ecom.ShowVoidedErrorMessage',
  HideMissingLineItemImagesInPaymentRequest: 'specs.ecom.HideMissingLineItemImagesInPaymentRequest',
  SupportSubscriptionDescriptionOnPaymentRequest: 'specs.ecom.SupportSubscriptionDescriptionOnPaymentRequest',
  ErrorHandlerOnStorefrontSdk: 'specs.ecom.ErrorHandlerOnStorefrontSdk',
  UseLayoutEffectInCheckout: 'specs.ecom.UseLayoutEffectInCheckout',
  CallCartV2FromCheckout: 'specs.ecom.CallCartV2FromCheckout',
  AlwaysCallCartV2FromCheckout: 'specs.ecom.alwaysCallCartV2FromCheckout',
  AddCartServiceToContext: 'specs.ecom.AddCartServiceToContext',
  ExpressLoaderInCheckout: 'specs.ecom.ExpressLoaderInCheckout',
  DeliveryOptionsSetFirstAsDefault: 'specs.ecom.deliveryOptionsSetFirstAsDefault',
  UseMarketingConsentApiForSubscription: 'specs.ecom.UseMarketingConsentApiForSubscription',
  StopSendingOriginInCheckoutUrl: 'specs.ecom.StopSendingOriginInCheckoutUrl',
  SupportDynamicBillingFieldsCheckout: 'specs.ecom.SupportDynamicBillingFieldsCheckout',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  CallCartV2FromCartComponents: 'specs.ecom.CallCartV2FromCartComponents',
  AddExemptTextToTaxNameWhenPartiallyExempt: 'specs.ecom.AddExemptTextToTaxNameWhenPartiallyExempt',
  ShowCheckoutOnEditorPreview: 'specs.ecom.ShowCheckoutOnEditorPreview',
  CallShowPaymentErrorModalAfterValidation: 'specs.ecom.CallShowPaymentErrorModalAfterValidation',
  CouponAlignmentInCartAndCheckout: 'specs.ecom.CouponAlignmentInCartAndCheckout',
  RevampDiscountsInCartAndCheckout: 'specs.ecom.RevampDiscountsInCartAndCheckout',
  SendPaymentTokenUndefinedFallback: 'specs.ecom.SendPaymentTokenUndefinedFallback',
  UseIsMobileForOneColumnView: 'specs.ecom.UseIsMobileForOneColumnView',
  FixImageDimensionsOnCart: 'specs.ecom.FixImageDimensionsOnCart',
  HandleCheckoutErrorStates: 'specs.ecom.HandleCheckoutErrorStates',
  overrideDeliveryCountriesOnlyOnShippingFlow: 'specs.ecom.overrideDeliveryCountriesOnlyOnShippingFlow',
  UpdateCartIconsSVGViewer: 'specs.ecom.UpdateCartIconsSVGViewer',
  VerifyCountryBeforeSkippingCustomerDetailsStep: 'specs.ecom.VerifyCountryBeforeSkippingCustomerDetailsStep',
  RegisterWebMcpTools: 'specs.ecom.RegisterWebMcpTools',
  SkipPlaceOrderButtonStateUpdatesInStep: 'specs.ecom.SkipPlaceOrderButtonStateUpdatesInStep',
  ShowOverviewTitleOnPaymentRequest: 'specs.ecom.ShowOverviewTitleOnPaymentRequest',
  ShowAllSubscriptionItemNames: 'specs.ecom.ShowAllSubscriptionItemNames',
  FixAutoZoomInputOnMobile: 'specs.ecom.FixAutoZoomInputOnMobile',
  UpdateCartOnBillingFieldsChange: 'specs.ecom.UpdateCartOnBillingFieldsChange',
  PaymentErrorNoCountryHandling: 'specs.ecom.paymentErrorNoCountryHandling',
  ShowDividersInPaymentRequestSummary: 'specs.ecom.ShowDividersInPaymentRequestSummary',
};

export const A11yIds = {
  SummarySection: 'summary-section',
};

export const MANDATORY_FIELDS_HIDDEN = [
  'countryCode',
  'state',
  'email',
  'firstName',
  'lastName',
  'street',
  'houseNumber',
  'address',
  'city',
  'zipCode',
  'phone',
];

export const HOLDER_ID_FIELD = 'holderId';
export const POLICIES_PATH = 'policies';
